import { CommonOperators, Condition, Operator } from '../Condition';
import ConditionVisibleControls from "./ConditionVisibleControls";

export default abstract class ConditionProperty {
  static readonly type: number;
  static readonly label: string;
  static readonly formFields: ConditionVisibleControls;

  constructor(protected condition: Condition) {
    this.condition = condition;
  }

  public getOperators(): Array<Operator> {
    return CommonOperators;
  }

  public getValueLabel(): string {
    return 'Compare with value';
}

  static showPath(operator: number): boolean {
    return this.formFields.fieldPath;
  }

  public getOperatorLabel(): string {
    const isNegative = this.condition.options.negative
    switch (this.condition.operator) {
      case Operator.CONTAIN_TYPE:
        return isNegative ? 'does not contain' : 'contains';
      case Operator.CONTAIN_PROPERTY_TYPE:
        return isNegative ? 'array does not contain object' : 'array contains object';
      case Operator.MATCH_TYPE:
        return isNegative ? 'does not match' : 'matches';
      case Operator.BOOLEAN_TYPE:
        return isNegative ? 'does not exist' : 'exists';
      case Operator.CLICK_TYPE:
        return 'is clicked';
      case Operator.LOAD_TYPE:
        return 'is loaded';
      case Operator.CHANGE_TYPE:
        return 'is changed';
      default:
        return isNegative ? 'is not' : 'is';
    }
  }

  abstract buildDescription(): string;
}
